import { browserSupportsWebAuthn } from "@simplewebauthn/browser";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { ERROR_MESSAGE } from "../../../constants/errorMessage";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";
import { validateEmail } from "../../../utils/validation";

export const useLogin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();

  const handleLogin = useCallback(
    (email: string, onError: (message: string) => void) => {
      const isValidEmail = validateEmail(email);

      if (!isValidEmail) return onError(ERROR_MESSAGE.invalidEmail);

      dispatch(appActions.showLoading());
      dispatch(
        authActions.checkUserEmail.started({
          email,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: ({ is_valid, has_passkey, has_phone }) => {
            const hasPhone = has_phone ?? true;
            if (!is_valid || !has_passkey || !browserSupportsWebAuthn())
              return navigateToPage(PageRoutes.LOGIN_PASSWORD, false, {
                email,
                hasPhone,
              });

            dispatch(
              authActions.challengePasskeyLogin.started({
                email,
                onComplete: () => dispatch(appActions.hideLoading()),
                onSuccess: (payload) => {
                  navigateToPage(PageRoutes.LOGIN_PASSKEY, false, {
                    email,
                    payload,
                  });
                },
                onError: (error) => {
                  navigateToPage(PageRoutes.LOGIN_PASSWORD, false, { 
                    email,
                    hasPhone,
                  });
                },
              }),
            );
          },
          onError: (error) => {
            navigateToPage(PageRoutes.LOGIN_PASSWORD, false, { 
              email,
              hasPhone: true, // エラー時はデフォルトでtrue
            });
          },
        }),
      );
    },
    [],
  );

  return { handleLogin };
};
